
import {createStore, applyMiddleware, combineReducers, compose} from 'redux'
import ReduxThunk from 'redux-thunk'
import * as authActions from './auth'
import * as usersActions from './users'
import * as foldersActions from './folders'
import * as organizationsActions from './organizations'
import * as documentsActions from './documents'
import * as importsActions from './imports'


const NODE_ENV = process.env.NODE_ENV || 'production'

let enhancer

if (NODE_ENV === 'development') {
    enhancer = compose(
        applyMiddleware(ReduxThunk),
        window.devToolsExtension ? window.devToolsExtension() : f => f
    )
} else {
    enhancer = applyMiddleware(ReduxThunk)
}

export const rootReducer = combineReducers({
    auth: authActions.reducer,
    users: usersActions.reducer,
    folders: foldersActions.reducer,
    organizations: organizationsActions.reducer,
    documents: documentsActions.reducer,
    imports: importsActions.reducer
})

export const initStore = (state) =>{

    state = state || {}
    state.auth = authActions.getIntialState(state)
    state.imports = importsActions.getIntialState(state)
    return createStore(
        rootReducer,
        state,
        enhancer
    )
}



// WEBPACK FOOTER //
// ./src/actions/index.js